export default __webpack_public_path__ + "static/media/dcgod-logo.6013f648.png";